<section class="container-fluid">
    <section class="row mobilePadding">
        <section class="offset-md-1 col-md-5 col-sm-12 col-xs-12 p-0">
            <section class="mt-2 mb-2">
                <span class="contactus-left-header">Please fill out the form below to get in touch</span>
            </section>
            <section class="mt-2 mb-2">
                <span class="requiredFields-text">All fields required unless otherwise noted</span>
            </section>

            <div class="container pl-0 mt-2 mb-2" [formGroup]="contactusForm">
                <section class="row mt-3">
                    <section class="col-lg-12 col-md-12 mb-2">
                        <span class="label-txt">Name</span>
                    </section>
                    <section class="col-lg-12 col-md-12">
                        <input class="form-control w-100 contactus-inputs" (focusout)="Validate($event);"
                            formControlName="name" (focus)="isInputFocused[0] = false" (blur)="isInputFocused[0] = true"
                            type="text">
                        <span class="error" *ngIf="f.name.errors?.required && !contactusForm.get('name').valid
                        && contactusForm.get('name').touched && contactusForm.get('name').value==''">
                            This field is required</span>
                        <span class="error" *ngIf="(alphaCheck || contactusForm.get('name').invalid) && contactusForm.get('name').touched
                            && contactusForm.get('name').value!=''">
                            This field accepts alphabetical characters only.</span>
                    </section>
                </section>
                <!-- //Title -->
                <section class="row mt-3">
                    <section class="col-lg-12 col-md-12 mb-2">
                        <span class="label-txt">Title </span>
                        <span class="optionalText">(Optional)</span>
                    </section>
                    <section class="col-lg-12 col-md-12">
                        <input class="form-control w-100 contactus-inputs" formControlName="title">
                    </section>
                </section>
                <!-- //Company -->
                <section class="row mt-3">
                    <section class="col-lg-12 col-md-12 mb-2">
                        <span class="label-txt">Company </span>
                        <span class="optionalText">(Optional)</span>
                    </section>
                    <section class="col-lg-12 col-md-12">
                        <input class="form-control w-100 contactus-inputs" formControlName="company">
                    </section>
                </section>
                <!-- //Buisness Email -->
                <section class="row mt-3">
                    <section class="col-lg-12 col-md-12 mb-2">
                        <span class="label-txt">Business Email</span>
                    </section>
                    <section class="col-lg-12 col-md-12">
                        <input class="form-control w-100 contactus-inputs" formControlName="businessEmail"
                            [ngClass]="{required:submitted && (f.businessEmail.errors?.required || f.businessEmail.errors?.pattern)}">
                        <span class="error" *ngIf="submitted && f.businessEmail.errors?.required">
                            This field is required</span>
                        <span class="error" *ngIf="submitted && f.businessEmail.errors?.pattern">
                            Invalid email address</span>
                    </section>
                </section>
                <!-- //confirmBusiness email  -->
                <section class="row mt-3">
                    <section class="col-lg-12 col-md-12 mb-2">
                        <span class="label-txt">Confirm Business Email</span>
                    </section>
                    <section class="col-lg-12 col-md-12">
                        <input class="form-control w-100 contactus-inputs" formControlName="confirmBusinessEmail"
                            [ngClass]="{required:submitted && (f.confirmBusinessEmail.errors?.required || f.confirmBusinessEmail.errors?.pattern || isEmailMismatch)}">
                        <span class="error" *ngIf="submitted && f.confirmBusinessEmail.errors?.required">
                            This field is required</span>
                        <span class="error" *ngIf="submitted && f.confirmBusinessEmail.errors?.pattern">
                            Invalid email address</span>
                        <span class="error" *ngIf="submitted && isEmailMismatch">Email Ids do not match</span>
                    </section>
                </section>
                <!-- //phone -->
                <section class="row mt-3">
                    <section class="col-lg-12 col-md-12 mb-2">
                        <span class="label-txt">Phone </span>
                        <span class="optionalText">(Optional)</span>
                    </section>
                    <section class="col-lg-12 col-md-12">
                        <input class="form-control w-100 contactus-inputs phone" (input)="onBlur($event)"
                            formControlName="phone" onkeypress="return /[0-9]/.test(event.key)"
                            (keyup)="formatPhoneNumber($event)" maxlength="12">
                        <span class="error" *ngIf="invaliadPhone">Phone number must be of 10 digit</span>
                    </section>
                </section>
                <!-- //commeents -->
                <section class="row mt-3">
                    <section class="col-lg-12 col-md-12 mb-2">
                        <span class="label-txt">Comments</span>
                        <a class="tool" placement="top" [ngbPopover]="errorPopContent"><img
                                src="../../../../assets/icons/faqs-plum.svg" alt="faq_reg" class="faq_contact" /></a>
                        <ng-template #errorPopContent>
                            * This field accepts alphanumeric characters and spaces as well. Special characters !,$,%,*,(,) and = are not accepted
                        </ng-template>
                        <span class="optionalText"> (Optional)</span>
                    </section>
                    <section class="col-lg-12 col-md-12">
                        <textarea rows='5' cols='10' class="form-control w-100 commentTextBox"
                            formControlName="comments" maxlength="250">

                    </textarea>
                    </section>
                </section>
                <section class="row mt-3">
                    <section class="col-lg-12 col-md-12 mb-2">
                        <re-captcha 
                        formControlName="recaptchaReactive" 
                        (resolved)="resolved($event)"
                        *ngIf="recaptchaEnabled"
                        [siteKey]="siteKey"
                        ></re-captcha>
                        <span *ngIf="submitted && contactusForm.get('recaptchaReactive').errors?.required &&
                            !contactusForm.get('recaptchaReactive').valid &&
                            contactusForm.get('recaptchaReactive').touched" class="defaultMessage" role="alert"
                            aria-live="assertive">
                            This is required
                        </span>
                    </section>
                </section>
                <section class="row mt-3">
                    <section class="col-md-4 p-0">
                        <button class="btn submit-btn w-100 " (click)="fetchContactFormDetails()">Submit</button>
                    </section>
                </section>

            </div>

            <div class="loc-succ" *ngIf="successMessage">
                <img src="../../../assets/icons/confirmation-positive-green.png">
                <span class="succ-msg">{{successMessage}}</span>
            </div>
        </section>
        <section class="offset-md-1 offset-lg-1 col-md-4 col-lg-4 mr-auto p-0">
            <span>
                <img class="officeImg" src="{{ imageUrl }}" alt="img" />
            </span>
            <section class="corpOffice-div container">
                <span>
                    <h3 class="officeTxt">Our corporate office</h3>
                </span>
                <section class="row mt-3 mb-3 addressWrapper">
                    <section class="col-md-12 col-lg-12 p-0">
                        <span>VaxServe</span>
                    </section>
                    <section class="col-md-12 col-lg-12 p-0">
                        <span>54 GlenMaura National Blvd STE 301</span>
                    </section>
                    <section class="col-md-12 col-lg-12 p-0">
                        <span>Moosic, PA- 18507-2101</span>
                    </section>
                </section>

                <section class="row">
                    <section class="col-md-3 col-lg-3 ">
                        <span class="phoneLabel">Phone :</span>
                    </section>
                    <section class="col-md-9 col-lg-9 pl-0">
                        <span class="phoneNumber"> 1-800-752-9338</span>
                    </section>
                    <section class="offset-md-3 offset-lg-3 col-md-9 col-lg-9 pl-0">
                        <span class="availableDays">(Mon-Fri :8:30 AM - 6:00 PM Eastern)</span>
                    </section>
                </section>
            </section>

        </section>
    </section>
</section>